// extracted by mini-css-extract-plugin
export default {"wrapper":"TermsPage_wrapper__hRKuM","title":"TermsPage_title__JRL3i","subTitle":"TermsPage_subTitle__HYG1i"};